class logoFavorite extends HTMLElement {
  constructor() {
    super()

    this.container = this.querySelector('.js-logo-favorite-container')
    this.track = this.querySelector('.js-logo-favorite-track')
    this.button = this.parentElement.querySelector('.play-button')
    this.speed = this.dataset.speed

    this.trackWidth = 0
    this.pos = 0
    this.start = null
    this.rafId = null
    this.isPlaying = true

    this.setup()
    this.animate = this.animate.bind(this)
    this.handleClickButton = this.handleClickButton.bind(this)

    if (this.button) {
      this.button.addEventListener('click', this.handleClickButton)
    }

    requestAnimationFrame(this.animate)
  }

  setup() {
    this.trackWidth = this.track.getBoundingClientRect().width

    this.clone = this.track.cloneNode(true)
    this.container.appendChild(this.clone)
  }

  animate(timestamp) {
    if (!this.isPlaying) {
      this.rafId = requestAnimationFrame(this.animate)
      return
    }

    if (this.pausedAt && this.start) {
      const pausedDuration = this.pausedAt - this.start
      this.start = timestamp - pausedDuration
      this.pausedAt = null
    }

    if (!this.start) this.start = timestamp

    const elapsed = timestamp - this.start
    this.pos = -(elapsed / 1000) * this.speed

    if (Math.abs(this.pos) >= this.trackWidth) {
      const overshoot = Math.abs(this.pos) - this.trackWidth
      this.pos = -overshoot
      this.start = timestamp
    }

    this.container.style.transform = `translateX(${this.pos}px)`

    this.rafId = requestAnimationFrame(this.animate)
  }

  handleClickButton(e) {
    e.preventDefault()

    if (!this.button.classList.contains('played')) {
      this.isPlaying = true
      this.button.classList.add('played')
      this.button.setAttribute('aria-label', 'Pause')
    } else {
      this.isPlaying = false
      this.pausedAt = Date.now()
      this.button.classList.remove('played')
      this.button.setAttribute('aria-label', 'Play')
    }
  }

  destroy() {
    cancelAnimationFrame(this.rafId)
    if (this.clone) this.clone.remove()
    if (this.button) {
      this.button.removeEventListener('click', this.handleClickButton)
    }
    this.container.style.transform = ""
    this.container.style.willChange = ""
  }
}

customElements.define('logo-favorite', logoFavorite)